/// <amd-module name="Build/Common/Library/SingletonManager" />
import { IDisposable } from "Build/Flux/Common"
import { Nullable } from "./Types";

export class SingletonManager {
    private _objects: { [key: string]: any } = {};

    public add<T extends IDisposable>(key: string, object: T) {
        this._objects[key] = object;
    }

    public get<T extends IDisposable>(key: string): Nullable<T> {
        return this._objects[key];
    }

    public remove<T extends IDisposable>(key: string) {
        if (!!this._objects[key]) {
            this._objects[key].dispose();
        }

        delete this._objects[key];
    }

    public dispose() {
        const objects = this._objects || {};
        Object.keys(objects).forEach(key => {
            objects[key].dispose();
        });

        this._objects = {};
    }
}

var ___manager: SingletonManager;
export function getSingletonManager() {
    if (!___manager) {
        ___manager = new SingletonManager();
    }

    return ___manager;
}
